import { Component, OnInit } from "@angular/core";
import { LazyLoadEvent } from "primeng/api";
import { UserService, HttpclientService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { SchoolSettingsService } from "../services/adminsettings.service";
import { PeriodUpdateWithTardyRequest } from "../services/PeriodUpdateWithTardyRequest";
import * as moment from "moment";

@Component({
	selector: "app-period-setup",
	templateUrl: "./period-setup.component.html",
	styleUrls: ["./period-setup.component.css"],
})
export class PeriodSetupComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private userService: UserService,
		private schoolSettingsService: SchoolSettingsService,
		private httpclientService: HttpclientService
	) {}

	report = {
		SchoolID: 0,
	};

	schoolList: any = [];
	//SchoolID;

	pagerows: any = 10;
	pagefirst: any = 0;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	subscription: any;
	loading: any = false;

	SelectedPeriod: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		// this.loadSchoolist();
		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "Select the school",
					});
				} else {
					this.report.SchoolID = this.schoolList[0].SchoolID;
					this.PeriodGetList();
				}
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.resetValidationInfo();
		this.report.SchoolID = value;
		this.PeriodGetList();
	}

	onRefresh() {
		this.resetValidationInfo();
		this.PeriodGetList();
	}

	onChangeStartTime(record) {
		record.errorMessage = "";
		if (record.StartTimeText) {
			var myTime = record.StartTimeText;
			if (myTime.length == 8) {
				myTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.StartTimeText);
			}
			record.StartTime = myTime;
			record.StartTimeText = moment(myTime).format("hh:mm A");

			record.StartTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.StartTimeText);
			record.EndTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.EndTimeText);
			if (moment(record.StartTime) > moment(record.EndTime)) {
				record.errorMessage = "Start time must be before End Time";
			}
		} else {
			record.StartTime = null;
		}
		//this.isUpdating = true
	}

	onChangeEndTime(record) {
		record.errorMessage = "";
		if (record.EndTimeText) {
			var myTime = record.EndTimeText;
			if (myTime.length == 8) {
				myTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.EndTimeText);
			}
			record.EndTime = myTime;
			record.EndTimeText = moment(myTime).format("hh:mm A");

			record.StartTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.StartTimeText);
			record.EndTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.EndTimeText);
			if (moment(record.StartTime) > moment(record.EndTime)) {
				record.errorMessage = "Start time must be before End Time";
			}
		} else {
			record.EndTime = null;
		}
	}

	onChangeTardyTime(record) {
		if (record.TardyTimeText) {
			var myTime = record.TardyTimeText;
			if (myTime.length == 8) {
				myTime = new Date(moment(new Date()).format("MM/DD/YYYY") + " " + record.TardyTimeText);
			}
			record.TardyTime = myTime;
			record.TardyTimeText = moment(myTime).format("hh:mm A");
		} else {
			record.TardyTime = null;
		}
	}

	/* Processing TABLE Data  */

	lstAllRecords;

	PeriodGetList() {
		if (!this.report.SchoolID) {
			this.lstAllRecords = [];
			return;
		}

		this.loading = true;

		var result = this.schoolSettingsService.PeriodList(this.report.SchoolID);
		result.subscribe((response) => {
			this.lstAllRecords = response;

			$.each(this.lstAllRecords, function (index, result) {
				result.StartTimeText = moment(result.StartTime).format("hh:mm A");
				result.EndTimeText = moment(result.EndTime).format("hh:mm A");
				result.TardyTimeText = moment(result.TardyTime).format("hh:mm A");
				result.saved = false;
				result.issaving = false;
				result.errorMessage = "";
			});

			this.loading = false;
		});
	}

	Save(record) {
		this.isProcessing = true;

		record.saved = false;
		record.issaving = true;

		var StartTime = "01/01/1900 " + moment(record.StartTime).format("HH:mm A");
		var EndTime = "01/01/1900 " + moment(record.EndTime).format("HH:mm A");
		var TardyTime = "01/01/1900 " + moment(record.TardyTime).format("HH:mm A");

		let parms: PeriodUpdateWithTardyRequest = {
			PeriodID: record.PeriodID,
			PeriodDesc: record.PeriodDesc,
			StartTime: StartTime,
			EndTime: EndTime,
			TardyTime: TardyTime,
		};

		var result = this.schoolSettingsService.PeriodUpdateWithTardy(parms);

		result.subscribe((response) => {
			record.issaving = false;
			record.saved = true;
			setTimeout(function () {
				record.saved = false;
			}, 2000);
			this.selectService.SchoolRefresh("refresh");

			this.isProcessing = false;
		});
	}
	testvalidationpassed = false;
	testvalidationfailed = false;
	testvalidationerrormessage = "";

	private resetValidationInfo() {
		this.testvalidationpassed = false;
		this.testvalidationfailed = false;
		this.testvalidationerrormessage = "";
	}

	Test() {
		this.isProcessing = true;

		this.resetValidationInfo();

		var result = this.schoolSettingsService.PeriodValidity(this.report.SchoolID);

		result.subscribe((response: any) => {
			this.isProcessing = false;
			this.testvalidationerrormessage = response;

			if (response) {
				this.testvalidationpassed = false;
				this.testvalidationfailed = true;
			} else {
				this.testvalidationpassed = true;
				this.testvalidationfailed = false;
			}

			var that = this;
			setTimeout(function () {
				that.resetValidationInfo();
			}, 2000);
		});
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedPeriod = val.data;
	}
	onRowUnselect(val) {
		this.SelectedPeriod = null;
	}
	onRowDblClick(Semester) {
		this.SelectedPeriod = Semester;
	}
}
